export default __webpack_public_path__ + "static/media/bexio-icon.cf394dfb.png";